export default function ClientPTSection() {
  return <>Client - Your PT</>;
}
